// export const addItemToCart = (itemDetail) => ({
//     type: 'ADD_ITEM_TO_CART',
//     payload: itemDetail
// });

// export const updateItemCart = (selectedItems) => ({
//     type: 'UPDATE_ITEM_CART',
//     payload: selectedItems
// });

export const removeItemFromCart = (remainingItems) => ({
    type: 'REMOVE_ITEM_FROM_CART',
    payload: remainingItems
});

export const resetItemCart = () => ({
    type: 'RESET_ITEM_CART'
});

export function addItemToCart(itemDetail) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'ADD_ITEM_TO_CART',
                payload: itemDetail
            });
            resolve(true)
        });
    }
};
export function updateItemCart(selectedItems) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'UPDATE_ITEM_CART',
                payload: selectedItems
            });
            resolve(true)
        });
    }
};